import type { Route } from '@angular/router';

import { AuthFailureGuard, AuthLogoutGuard } from '@evc/platform';
import type { ImportAsyncComponent } from '@shared/types/utils.type';

import { productSupportCategoryGuard } from './guard/product-support-category.guard';
import { PRODUCT_KINDS } from './product-support/product-support.type';

const importPageNotFoundComponent: ImportAsyncComponent = () =>
  import('@shared/components/page-not-found/page-not-found.component').then(
    (m) => m.PageNotFoundComponent,
  );

export const appRoutes: Route[] = [
  {
    path: 'logout',
    canActivate: [AuthLogoutGuard],
    loadComponent: importPageNotFoundComponent,
    data: { logout: true },
  },
  {
    path: 'auth-fail',
    canActivate: [AuthFailureGuard],
    loadComponent: importPageNotFoundComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: PRODUCT_KINDS.INSTRUMENTS,
  },
  {
    path: ':category',
    canMatch: [productSupportCategoryGuard],
    loadComponent: () =>
      import('./product-support/home/home.component').then((m) => m.HomeComponent),
  },
  {
    path: ':category/:slug',
    canMatch: [productSupportCategoryGuard],
    loadComponent: () =>
      import('./product-support/support-details/support-details').then(
        (m) => m.SupportDetailsComponent,
      ),
  },
  {
    path: '**',
    loadComponent: importPageNotFoundComponent,
  },
];
